// extracted by mini-css-extract-plugin
export default {"base":"X2P42","loadingSpinner":"lMoER","suggestionContainer":"uhbCi","suggestion":"dGJri","noResults":"FiZ2U","selected":"aEDFT"};